import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { utilities } from '@weatherbug/common';
import { reduxConnect } from '../../../common';
import { translate } from '../../../common/translation/translate';
import { WeatherDetailsListItem,
    WeatherDetailsCellContainerLeft,
    WeatherDetailsCellContainerRight,
    WeatherDetailsCellLabel,
    WeatherDetailsCellValue } from '../weatherDetailsStyledComponents';
import { isValidDisplayValue } from './formatObsData';
import { getWindDirection } from '../../../common/utilities/unitUtils';
const { units } = utilities;
const defaultObsValue = '--';

const mapStoreStateToProps = storeState => {
    const { selectedStationObservations, units: storeStateUnits } =  storeState ?? {};
    const { wda: windDirectionAvg, wsa: windSpeedAverage, h: humidity } = selectedStationObservations?.data?.wsobs?.so ?? {};
    const { windUnit } = storeStateUnits ?? {};

    return {
        humidity,
        windDirectionAvg,
        windSpeedAverage,
        windUnit
    };
};

const mapDispatchToProps = {
};
// eslint-disable-next-line react/display-name
export const HumidityAndAverageWindView = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ humidity, windDirectionAvg, windSpeedAverage, windUnit }) => {
    const windSpeedUnitAbbrev = units.speedUnitsEnum[windUnit];
    
    const windDirectionLabelDisplay = windDirectionAvg >= 0 && isValidDisplayValue(windDirectionAvg) ? getWindDirection(windDirectionAvg) : '';
    
    const displayAverageWind = windSpeedAverage >= 0 && isValidDisplayValue(windSpeedAverage) ? `${windDirectionLabelDisplay} ${windSpeedAverage} ${windSpeedUnitAbbrev}` : defaultObsValue;
    
    const displayHumidity = humidity >= 0 ? `${humidity}%` : defaultObsValue;

    return (
        <WeatherDetailsListItem key='humidity-avg.wind'>
            <WeatherDetailsCellContainerLeft>
                <WeatherDetailsCellLabel>{translate('humidity')}</WeatherDetailsCellLabel>
                <WeatherDetailsCellValue>{displayHumidity}</WeatherDetailsCellValue>
            </WeatherDetailsCellContainerLeft>
            <WeatherDetailsCellContainerRight>
                <WeatherDetailsCellLabel>{translate('averageWind')}</WeatherDetailsCellLabel>
                <WeatherDetailsCellValue>{displayAverageWind}</WeatherDetailsCellValue>
            </WeatherDetailsCellContainerRight>
        </WeatherDetailsListItem>
    );
}));

HumidityAndAverageWindView.propTypes = {
    humidity: PropTypes.number,
    windDirectionAvg: PropTypes.string,
    windSpeedAverage: PropTypes.number,
    windUnit: PropTypes.number
};

HumidityAndAverageWindView.displayName = 'HumidityAndAverageWindView';
